import { render, staticRenderFns } from "./ProducedContent.vue?vue&type=template&id=082debce&"
import script from "./ProducedContent.vue?vue&type=script&lang=js&"
export * from "./ProducedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports